let baseUrl
if (process.env.NODE_ENV === 'development') {
  baseUrl = {
    RMM: 'https://deviceon.wise-paas.com',
    // RMM: 'http://172.22.12.254:8088',
    // RMM: 'https://portal-deviceonqa-eks008.sa.wise-paas.com/',
    // RMM: 'http://deviceon-sq.japaneast.cloudapp.azure.com',

    // DeviceMonitoringARK
    // RMM: 'http://deviceon-ark.southeastasia.cloudapp.azure.com',

    // Rafeal
    // RMM: 'http://172.22.12.145:8080/',

  }
} else {
  baseUrl = {
    // RMM: 'https://deviceon.wise-paas.com',
    RMM: window.location.origin,
  }
}
let oRMM = {}
if (typeof (Storage) !== 'undefined') {
  if (typeof (localStorage.RMMGlobal) !== 'undefined') {
    oRMM = JSON.parse(localStorage.RMMGlobal)
  }
}
if (oRMM.urlSearch) {
  let sParam = 'server'
  let sServer = ''
  let sPageURL = oRMM.urlSearch.substring(1)
  let sURLVariables = sPageURL.split('&')
  for (let i = 0; i < sURLVariables.length; i++) {
    let sParameterName = sURLVariables[i].split('=')
    if (sParameterName[0] === sParam) {
      sServer = sParameterName[1]
      break
    }
  }

  if (sServer !== '') {
    baseUrl = {
      RMM: sServer
    }
  }
}
export default baseUrl
